import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import HeaderLink from '../components/HeaderLink';
import SocialMedia from '../components/SocialMedia';
import HeaderLang from '../components/HeaderLang';
import logo from '../logo.svg';
import '../styles/header.css';
import LinkBuilder from '../components/LinkBuilder';
import { useTranslation } from 'react-i18next';

const languages = [
  { name: 'en', label: 'EN', activated: false },
  { name: 'de', label: 'DE', activated: false },
  { name: 'ru', label: 'RU', activated: false },
  { name: 'fr', label: 'FR', activated: false },
  { name: 'cn', label: 'CN', activated: false },
  { name: 'jp', label: 'JP', activated: false },
];

const Header = () => {
  const { lang = 'en' } = useParams();
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { num: 1, name: t('header.notes'), url: '/notes/' },
    { num: 2, name: t('header.travel'), url: '/travel/' },
    { num: 3, name: t('header.creations'), url: '/creations/' },
    { num: 4, name: t('header.knowledge'), url: '/knowledge/' },
    { num: 5, name: t('header.tools'), url: '/tools/' },
    { num: 6, name: t('header.me'), url: '/me/' },
  ];

  const switchLanguage = (newLang) => {
    if (newLang !== i18n.language) {
      i18n.changeLanguage(newLang).then(() => {
        const currentPath = window.location.pathname.replace(`/${lang}`, '').replace(/\/+$/, '');
        const newPath = newLang === 'en' ? `${currentPath}/` : `/${newLang}${currentPath}/`;
        navigate(newPath, { replace: true });
      });
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header>
      <div className="bl-header">
        <div className="el-links-p1">
          {links.slice(0, 3).map(link => (
            <HeaderLink key={link.num} num={link.num} name={link.name} url={link.url} buildLinkURL={LinkBuilder} lang={lang} />
          ))}
        </div>
        <div className="el-center-group" style={menuOpen ? {position: "fixed", top: "12px"} : {}}>
          <div className="el-logo" onClick={() => navigate(lang === 'en' ? '/' : `/${lang}/`)}>
            <img src={logo} alt="Logo" />
          </div>
          <div className="el-social-media-container">
            <SocialMedia />
          </div>
        </div>
        <div className="el-links-p2">
          {links.slice(-3).map(link => (
            <HeaderLink key={link.num} num={link.num} name={link.name} url={link.url} buildLinkURL={LinkBuilder} lang={lang} />
          ))}
        </div>
        <div className="el-lang">
          {languages.map(language => (
            <HeaderLang key={language.name} name={language.name} label={language.label} changeLanguage={() => switchLanguage(language.name)} activated={lang} />
          ))}
        </div>
        <div className="burger-menu-icon" style={menuOpen ? {position: "fixed", top: "39.5px"} : {}} onClick={toggleMenu}>
          {menuOpen ?
          (<img alt="" src="/icons/footer-burger-menu-opened.svg" />) :
          (<img alt="" src="/icons/footer-burger-menu-closed.svg" />)}
        </div>
        {menuOpen && (
          <div className="burger-menu-box open">
            <div className="burger-menu-content">
              <ul className="burger-links">
                {links.map(link => (
                  <li key={link.num} onClick={toggleMenu}>
                    <HeaderLink num={link.num} name={link.name} url={link.url} buildLinkURL={LinkBuilder} lang={lang} />
                  </li>
                ))}
              </ul>
              <div className="burger-social-media">
                <SocialMedia />
              </div>
              <div className="burger-language-switcher">
                {languages.map(language => (
                  <HeaderLang key={language.name} name={language.name} label={language.label} changeLanguage={() => switchLanguage(language.name)} activated={lang} />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
